import type { ListBuilderList } from '../../types';

/**
 * The filters that DEFINE one attention list each (its dashboard card's own
 * predicate). On its own list such a filter is locked and visible, so the row
 * population is explained; on every other list it is noise — the bar showed
 * "Wrong Number on File" and "Controlled, No Verified DEA" dropdowns on every
 * tab. Regulator Standing is deliberately NOT here: it is a useful
 * general filter on any of the lists.
 */
export const CARD_FILTER_KEYS = [
	'licenseNumberCollision',
	'licenseFailedLookup',
	'licenseControlledNoDea',
	'licenseHasReplacement',
	'licenseRecentlyFixed',
	'licenseRecentlyFixedWindow',
	'licenseClientCoverage',
	'licenseVerifiedExpiringSoon',
	'licenseLinkEnded',
	'licenseAdverseInForce',
	'licenseDuplicateLicense',
	'licenseSharedLicense',
] as const;

/** Rules hiding every card filter except the list's own. Cosmetic only. */
export function hideOtherCardFilters(
	own: ReadonlyArray<(typeof CARD_FILTER_KEYS)[number]>,
): NonNullable<ListBuilderList['filterRules']> {
	return Object.fromEntries(
		CARD_FILTER_KEYS.filter((key) => !own.includes(key)).map((key) => [
			key,
			{ hidden: true },
		]),
	);
}
